import { router } from "expo-router";
import React, { useEffect, useRef } from "react";
import { View, Animated, Platform } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { LinearGradient } from "expo-linear-gradient";
import Icons from "@/assets/icons";
import useAppStore from "@/store/app";
import { APP_BASE_URL } from "@/constants/Configs";
import FBTrackingService from "@/services/fbTrackingService";
import { TRACKING_EVENTS } from "@/constants/trackingEvents";

export default function Index() {
  const { isInitialized, hasSession, initData } = useAppStore();
  const progressAnim = useRef(new Animated.Value(0)).current;

  // Track app launch once on mount
  useEffect(() => {
    FBTrackingService.trackEvent(TRACKING_EVENTS.APP_LAUNCHED, {
      eventData: {
        platform: Platform.OS,
        version: Platform.Version,
      },
    });
  }, []);

  useEffect(() => {
    if (!isInitialized) {
      Animated.timing(progressAnim, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: false,
      }).start();
    }
  }, [isInitialized]);

  useEffect(() => {
    if (isInitialized) {
      let pathname = "/(tabs)/feeds";
      const params = { ...initData?.params };
      if (hasSession) {
        if (initData?.route && initData?.route !== "/") {
          pathname = initData?.route;
        }
        delete params.redirectPath;
        router.replace({
          pathname: pathname as any,
          params,
        });
      } else {
        if (Platform.OS === "web") {
          let pathname = "";
          let params: any = undefined;
          if (initData?.params?.redirectPath) {
            pathname = initData?.params?.redirectPath as string;
          } else if (initData?.route === "/feeds") {
            pathname = "class-actions";
            params = {
              claim: initData?.params?.first,
            };
          }
          window.location.href =
            APP_BASE_URL +
            `/${pathname}?${new URLSearchParams(params).toString()}`;
        } else {
          router.replace("/welcome");
        }
      }
    }
  }, [isInitialized, hasSession]);

  return (
    <LinearGradient colors={["#369449", "#243D3C"]} style={styles.container}>
      <View style={styles.centerContent}>
        {/* Bird Icon */}
        <View style={styles.birdContainer}>
          <Icons.Logo width={120} height={120} />
        </View>
        {/* Progress Bar */}
        <View style={styles.progressBarBg}>
          <Animated.View
            style={[
              styles.progressBar,
              {
                width: progressAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: ["0%", "100%"],
                }),
              },
            ]}
          />
        </View>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  centerContent: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  birdContainer: {
    marginBottom: 40,
  },
  progressBarBg: {
    width: 180,
    height: 8,
    borderRadius: 4,
    backgroundColor: "#2C3A39",
    overflow: "hidden",
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: "#22C55E",
  },
});
